export default __webpack_public_path__ + "static/radovi1-a3fbba4b9692fdd60da7665da8a00487.png";